import React from "react";

export const getUrlParms = () => {
  const args = new Object();
  const query = location.search.substring(1);//获取查询串
  const pairs = query.split("&");//在逗号处断开
  for (let i = 0; i < pairs.length; i++) {
    const pos = pairs[i].indexOf('=');//查找name=value
    if (pos == -1) continue;//如果没有找到就跳过
    const argname = pairs[i].substring(0, pos);//提取name
    const value = pairs[i].substring(pos + 1);//提取value
    if (argname == "keywords") {
      args[argname] = pageConfig.keywords;
      continue;
    }
    try {
      args[argname] = decodeURIComponent(value);//存为属性
    } catch (e) {
      args[argname] = value;//存为属性
    }
  }
  return args;
};

export const getStaticParams = () => {
  const str = location.search || location.hash;
  const regCosite = /^.*cosite=([^&]*).*$/;
  const regTrackid = /^.*trackid=([^&]*).*$/;
  const regLocation = /^.*location=([^&]*).*$/;
  const regKeywordid = /^.*keywordid=([^&]*).*$/;
  const regBt = /^.*bt=([^&]*).*$/;
  const regPid = /^.*pid=([^&]*).*$/;
  const regPtid = /^.*ptid=([^&]*).*$/;
  const regDebug = /^.*debug=([^&]*).*$/;

  const cosite = regCosite.test(str) ? str.replace(regCosite, "$1") : "";
  const trackid = regTrackid.test(str) ? str.replace(regTrackid, "$1") : "";
  const getLocation = regLocation.test(str)
    ? str.replace(regLocation, "$1")
    : "";
  const keywordid = regKeywordid.test(str)
    ? str.replace(regKeywordid, "$1")
    : "";
  const bt = regBt.test(str) ? str.replace(regBt, "$1") : "";
  const p4pid = (window.urlParams && window.urlParams.p4pid) || "";
  const pid = regPid.test(str) ? str.replace(regPid, "$1") : "";
  const ptid =
    (window.urlParams && window.urlParams.ptid) ||
    (regPtid.test(str) ? str.replace(regPtid, "$1") : "");
  const debug = regDebug.test(str) ? str.replace(regDebug, "$1") : "";

  const count = 20;

  return {
    cosite,
    trackid,
    location: getLocation,
    keywordid,
    bt,
    p4pid,
    pid,
    ptid,
    count,
    debug,
  };
};

export const formatNumber = (val, decimals) => {
  const num = val - 0;
  let strNum = val;
  if (num && num >= 100000000) {
    strNum = (num / 100000000).toFixed(1) + "亿";
  } else if (num && num >= 10000) {
    strNum = (num / 10000).toFixed(1) + "万";
  } else {
    strNum = !num ? val + "" : num.toFixed(decimals);
  }
  return strNum.split(".");
};

export const getExpParams = (exp) => {
  let res = {};
  let configs = exp.split(";");
  configs.map((configStr) => {
    let key = configStr.split(":")[0];
    let val = configStr.split(":")[1];
    res[key] = val;
  });
  return res;
};

export const jsonpRequest = ({ url, callbackParamName }) => {
  return jsonp(url, {
    jsonpCallback: callbackParamName, // optional, 'callback' by default
  })
    .then((res) => res.json())
    .catch((err) => {
      console.log(
        `[jsonpRequest] catch Error: ${url}`,
        false,
        400,
        "Sys Error",
        `errors: ${JSON.stringify(err)}`
      );
    });
};

// ICON
const XINPIN_ICON =
  "https://img.alicdn.com/imgextra/i3/O1CN01VpQFw829djSwzMxd9_!!6000000008091-2-tps-68-36.png";
const YANXUAN_ICON =
  "https://img.alicdn.com/imgextra/i1/O1CN01zpjFe61ydJKMv2MHm_!!6000000006601-2-tps-126-36.png";
const GONGYEHANGJIAXUAN_ICON =
  "https://img.alicdn.com/imgextra/i4/O1CN01A7DbS929TekvDiuLq_!!6000000008069-2-tps-144-36.png";
const XIAODANDIINGZHI_ICON =
  "https://img.alicdn.com/imgextra/i3/O1CN01dXgJGR1xtVj09csq0_!!6000000006501-2-tps-118-36.png";
const DINGZHIPIN_ICON =
  "https://img.alicdn.com/imgextra/i2/O1CN01pPDhLq1Oo0Pv4gtIf_!!6000000001751-2-tps-68-36.png";
const PINPAIZHIYING_ICON =
  "https://img.alicdn.com/imgextra/i1/O1CN01EfJb981Fnhbm0f832_!!6000000000532-2-tps-180-56.png";
const PINPAISHOUQUAN_ICON =
  "https://img.alicdn.com/imgextra/i3/O1CN019kdAOt1byACbwkHjg_!!6000000003533-2-tps-90-28.png";

export const handleTagsObj = (tagObj) => {
  const yanxuan = [];
  const xinpin = [];
  const xiaodandingzhi = [];
  const dingzhipin = [];
  const gongyehangjiaxuan = [];
  const pinpaizhiying = [];
  const pinpaishouquan = [];

  const priceTag = [];
  const serviceTags = [];
  let isJglOffer = false;

  const keys = Object.keys(tagObj);

  // 实商 & 超工 & 工业品
  const isShili = keys.indexOf("SLSJ") >= 0;
  const isSuperFactory = keys.indexOf("CJGC") >= 0;
  // const isGyp = keys.indexOf("GYP") >= 0;
  // const isDzp = keys.indexOf("DZP") >= 0;

  // 价格标
  const isBaoyou = keys.indexOf("YJBY") >= 0;
  isBaoyou && priceTag.push(<span className="solt baoyou" key="yjby">一件包邮</span>);

  /**
   * --商品标--
   * 消费品：严选 > 新品 > 小单定制 > 定制品
   * 定制品：小单定制 > 定制品 > 严选 > 新品
   * 工业品：工业行家选 > 品牌直营 > 品牌授权
   */
  keys.map((key) => {
    switch (key) {
      case "_1688_YX":
        yanxuan.push(<img className="icon" src={YANXUAN_ICON} />);
        break;
      case "XP":
        xinpin.push(<img className="icon" src={XINPIN_ICON} />);
        break;
      case "XDDZ":
        xiaodandingzhi.push(
          <img className="icon" src={XIAODANDIINGZHI_ICON} />
        );
        break;
      case "DZP":
        dingzhipin.push(<img className="icon" src={DINGZHIPIN_ICON} />);
        break;
      case "GYHJX":
        gongyehangjiaxuan.push(
          <img className="icon" src={GONGYEHANGJIAXUAN_ICON} />
        );
        break;
      case "PPZY":
        pinpaizhiying.push(<img className="icon" src={PINPAIZHIYING_ICON} />);
        break;
      case "PPSQ":
        pinpaishouquan.push(<img className="icon" src={PINPAISHOUQUAN_ICON} />);
        break;
      default:
        // 服务标
        if (
          tagObj[key].tagType1 === "holidayTag" ||
          tagObj[key].tagType1 === "extendProperties" ||
          (tagObj[key].tagType1 === "offerTag" && key !== "DZP")
        ) {
          serviceTags.push(
            <span className="tag service" key={tagObj[key].id}>{tagObj[key].tagName}</span>
          );
        }
        // 价格力商品判断
        if (tagObj[key].tagType1 === "价格力") {
          isJglOffer = true;
        }
    }
  });

  const productTagsTmp = [
    ...yanxuan,
    ...xinpin,
    ...xiaodandingzhi,
    ...dingzhipin,
    ...gongyehangjiaxuan,
    ...pinpaizhiying,
    ...pinpaishouquan,
  ];
  const productTag = productTagsTmp[0];
  return { isShili, isSuperFactory, productTag, priceTag, serviceTags, isJglOffer };
};

export const handleCoupon = (tags) => {
  /**
   * 新人首单立减金-priority-1：xrsdljj
   * 询盘有礼-priority-2：xpyl
   * 普通店铺优惠券-priority-3：ptdpyhq
   */
  const xrsdljj = [];
  const xpyl = [];
  const ptdpyhq = [];

  tags && tags.length > 0 &&
    tags.map((tag) => {
      switch (tag.type) {
        case "xrsdljj":
          tag.discountFeeYuan &&
            xrsdljj.push(
              <span className="tag coupon" key={tag.activityId}>{`新人减${tag.discountFeeYuan}元`}</span>
            );
          break;
        case "xpyl":
          tag.startFeeYuan &&
            tag.discountFeeYuan &&
            xpyl.push(
              <span className="tag coupon" key={tag.activityId}>{`满${tag.startFeeYuan}元减${tag.discountFeeYuan}`}</span>
            );
          break;
        case "ptdpyhq":
          tag.startFeeYuan &&
            tag.discountFeeYuan &&
            ptdpyhq.push(
              <span className="tag coupon" key={tag.activityId}>{`满${tag.startFeeYuan}元减${tag.discountFeeYuan}`}</span>
            );
          break;
      }
    });
  const promotionTag = [...xrsdljj, ...xpyl, ...ptdpyhq];
  return promotionTag[0];
};

export const convertBuyerTags = (tags) => {
  const res = { jiaGeLi: false, shangPinLi: false, chanDi: false };
  tags.map((tag) => {
    switch (tag.tagType1) {
      case "价格力":
        res.jiaGeLi = true;
        break;
      case "商品力":
        res.shangPinLi = true;
        break;
      case "产地":
        res.chanDi = true;
        break;
    }
  });
  return res;
};
